import classNames from 'classnames';
import { SnackbarProps } from './type';
import { IconDanger, IconInfoCircle } from '../icons';
export const Snackbar = ({
  style,
  state = 'info',
  size,
  type = 'text',
  children,
  className,
  hasIcon = true
}: SnackbarProps) => {
  const iconClassName = size === 'large' || type === 'title' ? 'w-6 h-6' : 'w-4 h-4';
  return <div className={classNames('relative flex flex-row gap-1 rounded border px-1 py-2', {
    '!py-3 font-bold': type === 'title',
    'text-body-16': type === 'title' && size === 'large',
    'text-body-14': type === 'text' && size === 'large' || type === 'title' && size !== 'large',
    'text-caption-12': type === 'text' && size !== 'large',
    'bg-surface-solid-0': style === 'outlined',
    'border-alert-info-dark text-alert-info-dark': state === 'info',
    'bg-alert-info-light': state === 'info' && style === 'filled',
    'border-alert-warning-dark text-alert-warning-dark': state === 'warning',
    'bg-alert-warning-light': state === 'warning' && style === 'filled',
    'border-alert-success-dark text-alert-success-dark': state === 'success',
    'bg-alert-success-light': state === 'success' && style === 'filled',
    'border-alert-error-dark text-alert-error-dark': state === 'error',
    'bg-alert-error-light': state === 'error' && style === 'filled'
  }, className)} data-sentry-component="Snackbar" data-sentry-source-file="snackbar.tsx">
            {hasIcon && (state === 'success' ? <IconDanger className={classNames(iconClassName, 'shrink-0')} /> : <IconInfoCircle className={classNames(iconClassName, 'shrink-0')} />)}

            <span>{children}</span>
        </div>;
};